import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import React from 'react';

import { useDropzone } from 'react-dropzone';

import styles from './UploadPdfArea.module.scss';

type Props = {
  files: Blob[];
  setFiles: Dispatch<SetStateAction<Blob[]>>;
  fileCategory?: string;
  multipleUploadAnnotation?: boolean;
};

const UploadPdfArea: FC<Props> = ({
  files,
  setFiles,
  fileCategory = 'アップロードしたいファイル',
  multipleUploadAnnotation = false,
  children,
}) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (droppedFiles) => {
      const addFiles = droppedFiles.map((dropFile) =>
        Object.assign(dropFile, {
          preview: URL.createObjectURL(dropFile),
        }),
      );
      setFiles([...files, ...addFiles]);
    },
  });

  useEffect(
    () => () => {
      files && files.length > 0 && files.forEach((file: any) => URL.revokeObjectURL(file.preview));
    },
    [files],
  );

  return (
    <>
      <div className={styles.upload_file} {...getRootProps()}>
        <div className="pc_only">
          <p className={styles.upload_file_lead}>
            『{fileCategory}』<br />
            をここにドラッグ&ドロップ{multipleUploadAnnotation && '(複数選択可)'}
          </p>
          <p className={styles.upload_file_sublead}>または</p>
        </div>
        <div className="sp_only">
          <p className={styles.upload_file_lead}>
            『{fileCategory}』を
            <br />
            選択してください{multipleUploadAnnotation && '(複数選択可)'}
          </p>
        </div>
        <label htmlFor="file-input" className={styles.select_files_button}>
          ファイルを選択
        </label>
        {children}
        <input {...getInputProps()} data-test="uploadFiles-input" />
      </div>
      <div className={styles.uploaded_preview_area}></div>
    </>
  );
};

export default UploadPdfArea;
